export default {
  message: {
    Tour: {
      continue: "Tiếp tục",
      back: "Quay lại",
      finish: "Hoàn tất"
    },
    Login: {
      title: "Đăng nhập phụ huynh",
      sign_in: "Đăng nhập",
      login_fail:
        "Xác thực thất bại. Vui lòng thử lại hoặc liên hệ trường học để được hỗ trợ đăng nhập.",
      forgot_password: "Quên mật khẩu",
      create_account: "Tạo tài khoản",
      password: "Mật khẩu",
      confirm_password: "Xác nhận mật khẩu",
      password_reminder: "Nhắc mật khẩu",
      enter_email: "Nhập địa chỉ email của bạn",
      validation_error: "Lỗi xác thực",
      password_reminder_error_no_user_register:
        "Không tìm thấy tên đăng nhập bạn đã nhập. Vui lòng thử lại hoặc tạo tài khoản mới.",
      password_reminder_error_no_user: "Không tìm thấy tên đăng nhập bạn đã nhập.",
      password_reminder_sent: "Email hướng dẫn đã được gửi đến {email}.",
      password_reminder_sent_message:
        "Email có thể mất vài phút để đến. Nếu không thấy trong hộp thư đến, hãy kiểm tra thư mục spam.",
      password_trouble_email: "Nếu vẫn gặp sự cố, vui lòng liên hệ {email}.",
      password_trouble_school:
        "Nếu vẫn gặp sự cố, vui lòng liên hệ trường học để được hỗ trợ.",
      return_to_sign_in: "Quay lại đăng nhập",
      create_my_account: "Tạo tài khoản của tôi",
      or_sign_in_with: "HOẶC ĐĂNG NHẬP BẰNG",
      password_reset: "Vui lòng chọn mật khẩu mới cho tài khoản của bạn.",
      password_reset_warning:
        "Nếu bạn không yêu cầu đổi mật khẩu, hãy liên hệ ngay với quản trị viên trường học.",
      password_update: "Chọn mật khẩu mới",
      password_update_confirm: "Xác nhận mật khẩu mới",
      password_update_success: "Mật khẩu mới của bạn đã được lưu."
    },
    AccountSettings: {
      title: "Cài đặt tài khoản",
      first_name: "Tên",
      last_name: "Họ",
      email: "Email",
      username: "Tên đăng nhập",
      password: "Mật khẩu",
      students: "Học sinh",
      teachers: "Giáo viên",
      external_id: "ID bên ngoài",
      phone: "Số điện thoại",
      phone_required: "Số điện thoại là bắt buộc",
      edit: "Chỉnh sửa",
      remove: "Xóa",
      add: "Thêm",
      remove_message: "Bạn có chắc muốn xóa học sinh này không?",
      yes: "Có",
      no: "Không",
      add_student: "Thêm học sinh",
      close: "Đóng",
      save: "Lưu thay đổi",
      cancel: "Hủy",
      student_alert_message: "Bạn phải nhập ít nhất một học sinh.",
      logout: "Đăng xuất"
    },
    TrialStatus: {
      title: "Update Trial Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      updatedSuccess: "Trial status updated successfully",
      updateError: "Failed to update trial status",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    Navbar: {
      my_meetings: "Cuộc họp của tôi",
      language: "Tiếng Việt",
      help: "Trợ giúp",
      account_settings: "Cài đặt tài khoản",
      user_management: "User Management",
      logout: "Đăng xuất"
    },
    SubNavbar: {
      meeting: "Cuộc họp",
      event: "Sự kiện",
      print: "In",
      email: "Email",
      export: "Xuất"
    },
    ConferenceCard: {
      add_edit_meetings: "Thêm/Sửa cuộc họp",
      opening: "Đang mở",
      closed: "Đã đóng"
    },
    Agenda: {
      full_agenda: "Lịch trình đầy đủ",
      empty_state_title: "Chúng tôi không tìm thấy hội nghị nào cho bạn.",
      empty_state_message: "Nếu có thắc mắc, vui lòng liên hệ đại diện trường học.",
      confirmation_modal_title: "Đã xác nhận lịch trình",
      confirmation_modal_message:
        "Lịch trình của bạn đã được xác nhận thành công và email đã được gửi cho bạn.",
      complete_button: "Hoàn tất!"
    },
    AgendaCard: {
      room: "Phòng không khả dụng",
      room_with_value: "Phòng: {room}",
      virtual_meeting: "Cuộc họp trực tuyến",
      all_conferences: "Tất cả hội nghị",
      conference: "Hội nghị",
      student: "Học sinh",
      meeting_with: "Gặp với",
      date_time: "Ngày/Giờ",
      meeting_type: "Loại cuộc họp",
      location: "Địa điểm",
      comment: "Ghi chú",
      action: "Hành động",
      delete: "Xóa",
      add_comment: "Thêm ghi chú",
      join: "Tham gia cuộc họp",
      choose_meeting_type: "Chọn loại cuộc họp",
      in_person: "Trực tiếp",
      phone: "Điện thoại",
      callback: "Gọi lại",
      virtual: "Trực tuyến",
      hybrid: "Kết hợp",
      unavailable: "Không khả dụng",
      tooltip_translator:
        "Dịch vụ phiên dịch không được đảm bảo nhưng trường sẽ cố gắng hết sức để cung cấp.",
      translator_requested: "Đã yêu cầu phiên dịch viên",
      clear_translator: "Xóa yêu cầu phiên dịch viên",
      need_translator: "Cần phiên dịch viên?",
      choose_language: "Chọn ngôn ngữ"
    },
    ScheduleMatrix: {
      no_teachers_title: "Chưa chọn giáo viên hoặc nhóm nào.",
      no_teachers_message: "Vui lòng chọn giáo viên để xem thời gian họp.",
      choose_teachers_button: "Xem giáo viên hoặc nhóm có sẵn",
      choose_student: "Cho học sinh nào?",
      cancel: "Hủy"
    },
    Matrix: {
      teachers: "Giáo viên",
      agenda: "Xem lại và tiếp tục"
    },
    DrawerTeachers: {
      teachers: "Giáo viên",
      name: "Tên",
      description: "Mô tả",
      student: "Học sinh",
      teacher_team: "Giáo viên/Nhóm",
      show_more: "Hiển thị thêm giáo viên",
      show_all: "Hiển thị tất cả giáo viên trong trường",
      selected: "Đã chọn ({count})",
      closeDrawer: "Tiếp tục lên lịch",
      search: "Tìm giáo viên hoặc nhóm",
      not_available: "Giáo viên này không có thời gian họp khả dụng vào {date}."
    },
    DrawerAgenda: {
      no_meetings_title: "Bạn chưa có cuộc họp nào được lên lịch.",
      no_meetings_message: "Sau khi chọn giáo viên và khung giờ, cuộc họp sẽ hiển thị ở đây.",
      new_meeting_label: "Mới",
      cancel_button: "Hủy",
      student_label: "Học sinh",
      meeting_type_location: "Loại/Địa điểm cuộc họp",
      comment_label: "Ghi chú",
      save_comment_button: "Lưu ghi chú",
      confirm_label: "Vui lòng xác nhận:",
      confirm_cancel_button: "Có, hủy cuộc họp với ",
      do_not_cancel_button: "Không hủy",
      confirm_agenda_button: "Xác nhận lịch trình này",
      confirm_agenda_message_line1: "Bạn luôn có thể quay lại và thay đổi.",
      confirm_agenda_message_line2: "Lịch trình hiện tại sẽ được gửi qua email cho bạn."
    },
    EmailConsent: {
      message:
        "Để bảo vệ quyền riêng tư và bảo mật của bạn, chúng tôi cần sự đồng ý của bạn để gửi thông tin đến địa chỉ email.",
      consent: "Đồng ý"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    }
  }
};
